import { BodyPart } from 'solarxr-protocol';

export const ALL_BODY_PARTS = [
  BodyPart.NONE,
  BodyPart.HEAD,
  BodyPart.NECK,
  BodyPart.CHEST,
  BodyPart.WAIST,
  BodyPart.HIP,
  BodyPart.LEFT_UPPER_LEG,
  BodyPart.RIGHT_UPPER_LEG,
  BodyPart.LEFT_LOWER_LEG,
  BodyPart.RIGHT_LOWER_LEG,
  BodyPart.LEFT_FOOT,
  BodyPart.RIGHT_FOOT,
  BodyPart.LEFT_LOWER_ARM,
  BodyPart.RIGHT_LOWER_ARM,
  BodyPart.LEFT_UPPER_ARM,
  BodyPart.RIGHT_UPPER_ARM,
  BodyPart.LEFT_HAND,
  BodyPart.RIGHT_HAND,
  BodyPart.LEFT_SHOULDER,
  BodyPart.RIGHT_SHOULDER,
  BodyPart.UPPER_CHEST,
  BodyPart.LEFT_HIP,
  BodyPart.RIGHT_HIP,
  BodyPart.LEFT_THUMB_METACARPAL,
  BodyPart.LEFT_THUMB_PROXIMAL,
  BodyPart.LEFT_THUMB_DISTAL,
  BodyPart.LEFT_INDEX_PROXIMAL,
  BodyPart.LEFT_INDEX_INTERMEDIATE,
  BodyPart.LEFT_INDEX_DISTAL,
  BodyPart.LEFT_MIDDLE_PROXIMAL,
  BodyPart.LEFT_MIDDLE_INTERMEDIATE,
  BodyPart.LEFT_MIDDLE_DISTAL,
  BodyPart.LEFT_RING_PROXIMAL,
  BodyPart.LEFT_RING_INTERMEDIATE,
  BodyPart.LEFT_RING_DISTAL,
  BodyPart.LEFT_LITTLE_PROXIMAL,
  BodyPart.LEFT_LITTLE_INTERMEDIATE,
  BodyPart.LEFT_LITTLE_DISTAL,
  BodyPart.RIGHT_THUMB_METACARPAL,
  BodyPart.RIGHT_THUMB_PROXIMAL,
  BodyPart.RIGHT_THUMB_DISTAL,
  BodyPart.RIGHT_INDEX_PROXIMAL,
  BodyPart.RIGHT_INDEX_INTERMEDIATE,
  BodyPart.RIGHT_INDEX_DISTAL,
  BodyPart.RIGHT_MIDDLE_PROXIMAL,
  BodyPart.RIGHT_MIDDLE_INTERMEDIATE,
  BodyPart.RIGHT_MIDDLE_DISTAL,
  BodyPart.RIGHT_RING_PROXIMAL,
  BodyPart.RIGHT_RING_INTERMEDIATE,
  BodyPart.RIGHT_RING_DISTAL,
  BodyPart.RIGHT_LITTLE_PROXIMAL,
  BodyPart.RIGHT_LITTLE_INTERMEDIATE,
  BodyPart.RIGHT_LITTLE_DISTAL,
];
export const FEET_BODY_PARTS = [BodyPart.LEFT_FOOT, BodyPart.RIGHT_FOOT];
export const FINGER_BODY_PARTS = [
  BodyPart.LEFT_THUMB_METACARPAL,
  BodyPart.LEFT_THUMB_PROXIMAL,
  BodyPart.LEFT_THUMB_DISTAL,
  BodyPart.LEFT_INDEX_PROXIMAL,
  BodyPart.LEFT_INDEX_INTERMEDIATE,
  BodyPart.LEFT_INDEX_DISTAL,
  BodyPart.LEFT_MIDDLE_PROXIMAL,
  BodyPart.LEFT_MIDDLE_INTERMEDIATE,
  BodyPart.LEFT_MIDDLE_DISTAL,
  BodyPart.LEFT_RING_PROXIMAL,
  BodyPart.LEFT_RING_INTERMEDIATE,
  BodyPart.LEFT_RING_DISTAL,
  BodyPart.LEFT_LITTLE_PROXIMAL,
  BodyPart.LEFT_LITTLE_INTERMEDIATE,
  BodyPart.LEFT_LITTLE_DISTAL,
  BodyPart.RIGHT_THUMB_METACARPAL,
  BodyPart.RIGHT_THUMB_PROXIMAL,
  BodyPart.RIGHT_THUMB_DISTAL,
  BodyPart.RIGHT_INDEX_PROXIMAL,
  BodyPart.RIGHT_INDEX_INTERMEDIATE,
  BodyPart.RIGHT_INDEX_DISTAL,
  BodyPart.RIGHT_MIDDLE_PROXIMAL,
  BodyPart.RIGHT_MIDDLE_INTERMEDIATE,
  BodyPart.RIGHT_MIDDLE_DISTAL,
  BodyPart.RIGHT_RING_PROXIMAL,
  BodyPart.RIGHT_RING_INTERMEDIATE,
  BodyPart.RIGHT_RING_DISTAL,
  BodyPart.RIGHT_LITTLE_PROXIMAL,
  BodyPart.RIGHT_LITTLE_INTERMEDIATE,
  BodyPart.RIGHT_LITTLE_DISTAL,
];
